import { render, staticRenderFns } from "./AddPob.vue?vue&type=template&id=55b614ad&scoped=true&"
import script from "./AddPob.vue?vue&type=script&lang=js&"
export * from "./AddPob.vue?vue&type=script&lang=js&"
import style0 from "./AddPob.vue?vue&type=style&index=0&id=55b614ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b614ad",
  null
  
)

export default component.exports